/**
 * @desc Yung-获取审批业务key
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<string>;
export function request(body: defs.tms.ApprovalBeforeRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/approval/getBusinessKey`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
